<template>
  <div class="box-outer">
    <label v-if="label" :for="`id_${name}`" class="label">{{ label }}</label>
    <datepicker
      :id="`id_${name}`"
      :name="name"
      :monday-first="true"
      :language="language"
      :placeholder="placeholder"
      :value="value"
      :disabled-dates="disabledDates"
      :class="{ error: errors.length }"
      class="datepicker"
      format="dd-MM-yyyy"
      @input="handleInput"
      @blur="handleInput"
    />
    <error-component :errors="errors" />
  </div>
</template>

<script>
import ErrorComponent from '@/components/Error'
import { pl, cs } from 'vuejs-datepicker/dist/locale'

// const TWO_WEEKS = 1209600000

export default {
  components: {
    ErrorComponent
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    errors: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Date],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabledDates: {
      type: [Boolean, Object],
      default() {
        return {
          from: new Date()
        }
      }
    }
  },
  data() {
    return {
      languages: {
        pl,
        cs
      }
    }
  },
  computed: {
    language() {
      return this.languages[this.$i18n.locale]
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.box-outer {
  margin: 28px 0 0;

  .field &,
  .fields-wrap & {
    margin: 0;
  }
}

.label {
  @include label;
}
</style>
